import * as React from 'react';

function SvgIconListEmpty(props) {
  return (
    <svg width={120} height={135} xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path d="M2.5 2.5v130h86.46l28.54-28.54V2.5H2.5z" stroke="#E7E7E7" strokeWidth={5} />
        <path
          d="M90.07 105.07H120V100H87a2 2 0 00-2 2v33h5.07v-29.93zM24 33v-5h72v5H24zm0 19v-5h72v5H24zm0 19v-5h72v5H24zm0 19v-5h50v5H24z"
          fill="#E7E7E7"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
}

export default SvgIconListEmpty;
